export default __webpack_public_path__ + "static/media/sales.99107db0.svg";